import ApiCore from "./api_core";

export default new class {
    get(property: string) {
        return ApiCore.getJson('global_properties', { property })
    }

    set(property: string, propertyValue: string) {
        return ApiCore.postJson('global_properties', {
            property, property_value: propertyValue
        })
    }
}